<template lang="pug">
	.delete-campaign(v-if="showed")
		.card
			.card-header Delete Campaign
			.card-body
				.card-fetching(v-show="!result && !error")
					.icon.fa.fa-spinner.fa-spin
				.card-confirmation(v-show="!error && result")
					span {{`Are you sure you want to delete this ${campaignName}campaign?`}}
				.card-error(v-show="!result && error")
					span {{error}}
			.card-footer
				button.btn.btn-cancel(@click="hide") Cancel
				button.btn.btn-confirm(type="submit" @click="deleteCampaign" :disabled="!result || error") Delete Campaign

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'CampaignActionsDelete',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {
			"Can Delete Campaign": function (error, success, campaignId) {
				if (!this.campaign || !campaignId || (this.campaign && this.campaign.id !== campaignId)) {
					this.error = 'Campaign not found';
					return;
				}
				if (error) {
					this.error = error;
					return;
				}
				if (success) this.result = true;
			},

			"Delete Campaign Completed": function (error, success, campaignId) {
				if (!this.campaign || !campaignId || (this.campaign && this.campaign.id !== campaignId)) {
					this.error = 'Campaign not found';
					return;
				}
				if (error) {
					this.error = error;
					return;
				}
				if (success) this.hide();
			}
		}
	},
	data() {

		this.Server = Server;

		return {
			campaign: {},
			result: false,
			error: false,
			campaignName: ''
		}
	},
	methods: {
		collectData(event, campaign) {

			this.result = false;
			this.error = false;

			this.campaign = campaign;
			if (this.campaign && this.campaign.id) {
				Server.sendToSocket({
					CanDeleteCampaign: {
						campaignId: this.campaign.id
					}
				});
				this.campaignName = `"${this.campaign.name}" `;
				return;
			}
			this.error = 'Campaign not found';
		},
		deleteCampaign() {

			if (this.campaign && !this.error) {

				this.error = false;
				this.result = false;

				Server.sendToSocket({
					DeleteCampaign: {
						campaignId: this.campaign.id
					}
				});

			}

		}

	}
}

</script>

<style lang="sass">

.delete-campaign
	position: absolute
	z-index: 2000
	top: 0
	left: 0
	bottom: 0
	right: 0
	display: flex
	justify-content: center
	align-items: center

	>.card
		width: 400px

		>.card-footer
			display: flex
			flex-direction: row
			justify-content: space-between

		>.card-body
			display: flex
			flex-direction: column
			gap: 0.5em
			height: 100px

			>.card-fetching
				font-size: 50px
				margin: auto

			>.card-error, >.card-confirmation
				margin: auto

			>.card-error
				color: red




</style>
